import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  StyledControlSectionContainer,
  StyledControlSectionHeader,
  StyledHeaderLabel,
  StyledHeaderTitle,
} from './sharedStyledComponents';
import { useToast } from '../../../../hooks/useToast';
import CardComponent from '../../../../components/Card.component';
import ButtonComponent from '../../../../components/Button.component';
import { systemControlService } from '../../../../redux/ControlPanel/SystemControl/SystemControl.service';

export const SystemSectionComponent: FC = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useToast();

  const importUsers = async () => {
    try {
      await systemControlService.importUsers();
      successToast(t('usersSuccessfullyImported'));
    } catch (_) {
      errorToast(`${t('importError')}`);
    }
  };

  return (
    <CardComponent>
      <StyledControlSectionContainer>
        <StyledControlSectionHeader>
          <StyledHeaderTitle>
            <StyledHeaderLabel>{t('system')}</StyledHeaderLabel>
          </StyledHeaderTitle>
        </StyledControlSectionHeader>

        <ButtonComponent
          handleClick={importUsers}
          textColor="#588fff"
          customColor="#ebf0ff"
        >
          {t('importUsers')}
        </ButtonComponent>
      </StyledControlSectionContainer>
    </CardComponent>
  );
};
